const config = {
  urlRootNode: process.env.REACT_APP_VERCEL_URL,
  Key: process.env.REACT_APP_VERCEL_KEY
};
export default config;
